// Automatically generated with Reach 0.1.7 (d2352c9e)
/* eslint-disable */
export const _version = '0.1.7';
export const _versionHash = '0.1.7 (d2352c9e)';
export const _backendVersion = 6;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        bids: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc3
          },
        closes: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v946;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v946;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v946;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endSecs: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v947;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v947;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v947;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        highestBidder: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v948;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v948;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v948;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        lastCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        minBid: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v1611;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v1611;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v978;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        owner: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v899;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v899;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v899;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        recvAddr: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v900;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v900;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v900;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        reservePrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v903;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v903;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v903;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        royalties: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v902;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v902;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v902;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        startPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v904;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v904;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v904;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v909;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v909;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v909;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          },
        tokenP: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v864, v865, v866, v867, v871] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624] = svs;
              return (await ((async () => {
                
                
                return v910;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684] = svs;
              return (await ((async () => {
                
                
                return v910;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = svs;
              return (await ((async () => {
                
                
                return v910;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc0, ctc0, ctc0],
      2: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
      4: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc3, ctc1],
      7: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc3, ctc1, ctc1],
      10: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Object({
    bidIncrementAbs: ctc1,
    bidIncrementRel: ctc1,
    deadline: ctc1,
    deadlineSecs: ctc1,
    deadlineStep: ctc1,
    maxDeadline: ctc1,
    recvAddr: ctc0,
    reservePrice: ctc1,
    royaltyAddr: ctc0,
    royaltyCents: ctc1,
    startPrice: ctc1,
    token: ctc2,
    tokenP: ctc2,
    unitAmount: ctc1
    });
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Tuple([ctc1]);
  const ctc7 = stdlib.T_Data({
    Bid_claim0: ctc5,
    Bid_close0: ctc5,
    Bid_getBid0: ctc6,
    Bid_getPurchase0: ctc6,
    Bid_touch0: ctc5
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v864, v865, v866, v867], secs: v869, time: v868, didSend: v32, from: v863 } = txn1;
  ;
  const v871 = v867;
  const v877 = stdlib.protect(ctc3, await interact.getParams(), {
    at: './donate.rsh:99:38:application',
    fs: ['at ./donate.rsh:82:18:application call to [unknown function] (defined at: ./donate.rsh:82:22:function exp)'],
    msg: 'getParams',
    who: 'Auctioneer'
    });
  const v878 = v877.recvAddr;
  const v879 = v877.royaltyAddr;
  const v880 = v877.royaltyCents;
  const v881 = v877.token;
  const v882 = v877.tokenP;
  const v883 = v877.reservePrice;
  const v884 = v877.startPrice;
  const v885 = v877.bidIncrementAbs;
  const v886 = v877.bidIncrementRel;
  const v887 = v877.deadline;
  const v888 = v877.maxDeadline;
  const v889 = v877.unitAmount;
  const v890 = v877.deadlineStep;
  const v891 = v877.deadlineSecs;
  const v892 = stdlib.tokenEq(v881, v882);
  const v893 = v892 ? false : true;
  stdlib.assert(v893, {
    at: './donate.rsh:100:11:application',
    fs: ['at ./donate.rsh:82:18:application call to [unknown function] (defined at: ./donate.rsh:82:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v894 = stdlib.ge(v880, stdlib.checkedBigNumberify('./donate.rsh:101:28:decimal', stdlib.UInt_max, 0));
  const v895 = stdlib.le(v880, stdlib.checkedBigNumberify('./donate.rsh:101:49:decimal', stdlib.UInt_max, 99));
  const v896 = v894 ? v895 : false;
  stdlib.assert(v896, {
    at: './donate.rsh:101:11:application',
    fs: ['at ./donate.rsh:82:18:application call to [unknown function] (defined at: ./donate.rsh:82:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v897 = stdlib.ge(v884, stdlib.checkedBigNumberify('./donate.rsh:102:26:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v897, {
    at: './donate.rsh:102:11:application',
    fs: ['at ./donate.rsh:82:18:application call to [unknown function] (defined at: ./donate.rsh:82:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v898 = stdlib.lt(v884, v883);
  stdlib.assert(v898, {
    at: './donate.rsh:103:11:application',
    fs: ['at ./donate.rsh:82:18:application call to [unknown function] (defined at: ./donate.rsh:82:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  
  const txn2 = await (ctc.sendrecv({
    args: [v864, v865, v866, v867, v871, v878, v879, v880, v883, v884, v885, v886, v887, v888, v881, v882, v889, v890, v891],
    evt_cnt: 14,
    funcNum: 1,
    lct: v868,
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v900, v901, v902, v903, v904, v905, v906, v907, v908, v909, v910, v911, v912, v913], secs: v915, time: v914, didSend: v85, from: v899 } = txn2;
      
      const v916 = stdlib.tokenEq(v909, v910);
      const v917 = v916 ? false : true;
      stdlib.assert(v917, {
        at: './donate.rsh:106:6:dot',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v909
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v910
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000),
        kind: 'to',
        tok: undefined
        });
      stdlib.assert(v917, {
        at: './donate.rsh:124:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v922 = stdlib.ge(v902, stdlib.checkedBigNumberify('./donate.rsh:125:27:decimal', stdlib.UInt_max, 0));
      const v923 = stdlib.le(v902, stdlib.checkedBigNumberify('./donate.rsh:125:48:decimal', stdlib.UInt_max, 99));
      const v924 = v922 ? v923 : false;
      stdlib.assert(v924, {
        at: './donate.rsh:125:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v925 = stdlib.ge(v904, stdlib.checkedBigNumberify('./donate.rsh:126:25:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v925, {
        at: './donate.rsh:126:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v926 = stdlib.lt(v904, v903);
      stdlib.assert(v926, {
        at: './donate.rsh:127:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v930 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:130:12:decimal', stdlib.UInt_max, 20000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:130:12:decimal', stdlib.UInt_max, 20000),
        kind: 'from',
        to: v864,
        tok: undefined
        });
      const v934 = stdlib.sub(v930, stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 80000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 80000),
        kind: 'from',
        to: v866,
        tok: undefined
        });
      const v935 = v899;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v900, v901, v902, v903, v904, v905, v906, v907, v908, v909, v910, v911, v912, v913], secs: v915, time: v914, didSend: v85, from: v899 } = txn2;
  const v916 = stdlib.tokenEq(v909, v910);
  const v917 = v916 ? false : true;
  stdlib.assert(v917, {
    at: './donate.rsh:106:6:dot',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  ;
  ;
  ;
  stdlib.assert(v917, {
    at: './donate.rsh:124:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v922 = stdlib.ge(v902, stdlib.checkedBigNumberify('./donate.rsh:125:27:decimal', stdlib.UInt_max, 0));
  const v923 = stdlib.le(v902, stdlib.checkedBigNumberify('./donate.rsh:125:48:decimal', stdlib.UInt_max, 99));
  const v924 = v922 ? v923 : false;
  stdlib.assert(v924, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v925 = stdlib.ge(v904, stdlib.checkedBigNumberify('./donate.rsh:126:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v925, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v926 = stdlib.lt(v904, v903);
  stdlib.assert(v926, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v930 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:130:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v934 = stdlib.sub(v930, stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v935 = v899;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v938, time: v937, didSend: v110, from: v936 } = txn3;
  ;
  ;
  const v942 = stdlib.addressEq(v935, v936);
  stdlib.assert(v942, {
    at: './donate.rsh:137:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Auctioneer'
    });
  const v945 = 'Start Auction';
  stdlib.protect(ctc4, await interact.log(v945), {
    at: './donate.rsh:141:40:application',
    fs: ['at ./donate.rsh:141:7:application call to [unknown function] (defined at: ./donate.rsh:141:25:function exp)'],
    msg: 'log',
    who: 'Auctioneer'
    });
  
  let v946 = stdlib.checkedBigNumberify('./donate.rsh:173:24:decimal', stdlib.UInt_max, 0);
  let v947 = v913;
  let v948 = v899;
  let v949 = true;
  let v950 = v937;
  let v953 = v938;
  let v956 = v934;
  let v957 = stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1);
  let v958 = stdlib.checkedBigNumberify('./donate.rsh:106:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v949;})()) {
    const v973 = stdlib.add(v946, v905);
    const v974 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v975 = stdlib.mul(v974, v906);
    const v976 = stdlib.add(v946, v975);
    const v977 = stdlib.gt(v973, v976);
    const v978 = v977 ? v973 : v976;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn4;
    switch (v1093[0]) {
      case 'Bid_claim0': {
        const v1096 = v1093[1];
        ;
        ;
        undefined;
        const v1118 = stdlib.addressEq(v1092, v900);
        const v1119 = stdlib.ge(v946, v903);
        const v1120 = v1118 ? v1119 : false;
        stdlib.assert(v1120, {
          at: './donate.rsh:262:18:application',
          fs: ['at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1125 = stdlib.sub(v957, v957);
        ;
        const v1126 = null;
        await txn4.getOutput('api', 'v1126', ctc4, v1126);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v1125;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_close0': {
        const v1198 = v1093[1];
        ;
        ;
        undefined;
        const v1237 = null;
        await txn4.getOutput('api', 'v1237', ctc4, v1237);
        const v1244 = stdlib.lt(v953, v947);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = v1244;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1300 = v1093[1];
        const v1301 = v1300[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1319 = stdlib.add(v958, v1301);
        ;
        undefined;
        const v1351 = stdlib.lt(v953, v947);
        const v1358 = stdlib.ge(v1301, v978);
        const v1359 = v1351 ? v1358 : false;
        const v1360 = stdlib.ge(v1301, v904);
        const v1361 = v1359 ? v1360 : false;
        stdlib.assert(v1361, {
          at: './donate.rsh:212:18:application',
          fs: ['at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1365 = stdlib.sub(v1319, v946);
        ;
        const v1366 = null;
        await txn4.getOutput('api', 'v1366', ctc4, v1366);
        const v1372 = stdlib.add(v947, stdlib.checkedBigNumberify('./donate.rsh:161:33:decimal', stdlib.UInt_max, 60));
        const cv946 = v1301;
        const cv947 = v1372;
        const cv948 = v1092;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1365;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1402 = v1093[1];
        const v1403 = v1402[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1421 = stdlib.add(v958, v1403);
        ;
        undefined;
        const v1479 = stdlib.ge(v953, v947);
        const v1480 = stdlib.lt(v946, v903);
        const v1481 = v1479 ? v1480 : false;
        const v1482 = stdlib.ge(v1403, v903);
        const v1483 = v1481 ? v1482 : false;
        stdlib.assert(v1483, {
          at: './donate.rsh:238:18:application',
          fs: ['at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1487 = stdlib.sub(v1421, v946);
        ;
        const v1488 = null;
        await txn4.getOutput('api', 'v1488', ctc4, v1488);
        const cv946 = v1403;
        const cv947 = v947;
        const cv948 = v1092;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1487;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1504 = v1093[1];
        ;
        ;
        undefined;
        const v1599 = null;
        await txn4.getOutput('api', 'v1599', ctc4, v1599);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      }
    
    }
  const v1606 = stdlib.add(v946, v905);
  const v1607 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1608 = stdlib.mul(v1607, v906);
  const v1609 = stdlib.add(v946, v1608);
  const v1610 = stdlib.gt(v1606, v1609);
  const v1611 = v1610 ? v1606 : v1609;
  const v1613 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
  const v1614 = stdlib.mul(v902, v1613);
  const v1616 = stdlib.add(v1614, v1613);
  const v1617 = stdlib.sub(v958, v1616);
  const v1618 = stdlib.ge(v946, v903);
  const v1619 = stdlib.add(v1617, v1614);
  const v1620 = stdlib.add(v1619, v1613);
  const v1624 = stdlib.sub(v958, v1620);
  ;
  if (v1618) {
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1628, time: v1627, didSend: v817, from: v1626 } = txn4;
    ;
    const v1630 = stdlib.addressEq(v871, v1626);
    stdlib.assert(v1630, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1618) {
      const v1635 = stdlib.sub(v957, v957);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1684 = stdlib.sub(v957, v957);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1688, time: v1687, didSend: v817, from: v1686 } = txn4;
    ;
    const v1690 = stdlib.addressEq(v871, v1686);
    stdlib.assert(v1690, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1618) {
      const v1695 = stdlib.sub(v1684, v1684);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Bid_claim(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_claim expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_claim expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc4,
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1019 = ctc.selfAddress();
  const v1021 = stdlib.protect(ctc4, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:257:9:application call to [unknown function] (defined at: ./donate.rsh:257:9:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_claim0" (defined at: ./donate.rsh:256:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: 'in',
    who: 'Bid_claim'
    });
  const v1023 = stdlib.addressEq(v1019, v900);
  const v1024 = stdlib.ge(v946, v903);
  const v1025 = v1023 ? v1024 : false;
  stdlib.assert(v1025, {
    at: './donate.rsh:257:23:application',
    fs: ['at ./donate.rsh:257:9:application call to [unknown function] (defined at: ./donate.rsh:257:14:function exp)', 'at ./donate.rsh:257:9:application call to [unknown function] (defined at: ./donate.rsh:257:9:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_claim0" (defined at: ./donate.rsh:256:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: null,
    who: 'Bid_claim'
    });
  
  const v1037 = ['Bid_claim0', v1021];
  
  const txn1 = await (ctc.sendrecv({
    args: [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978, v1037],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:260:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:260:22:decimal', stdlib.UInt_max, 0), v910]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
      
      switch (v1093[0]) {
        case 'Bid_claim0': {
          const v1096 = v1093[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:260:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:260:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v910
            });
          undefined;
          const v1118 = stdlib.addressEq(v1092, v900);
          const v1120 = v1118 ? v1024 : false;
          stdlib.assert(v1120, {
            at: './donate.rsh:262:18:application',
            fs: ['at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
            msg: null,
            who: 'Bid_claim'
            });
          const v1125 = stdlib.sub(v957, v957);
          sim_r.txns.push({
            amt: v957,
            kind: 'from',
            to: v900,
            tok: v909
            });
          const v1126 = null;
          const v1127 = await txn1.getOutput('api', 'v1126', ctc3, v1126);
          
          const v10815 = v946;
          const v10816 = v947;
          const v10817 = v948;
          const v10821 = v956;
          const v10822 = v1125;
          const v10830 = stdlib.add(v946, v905);
          const v10831 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v10832 = stdlib.mul(v10831, v906);
          const v10833 = stdlib.add(v946, v10832);
          const v10834 = stdlib.gt(v10830, v10833);
          const v10835 = v10834 ? v10830 : v10833;
          const v10836 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
          const v10837 = stdlib.mul(v902, v10836);
          const v10838 = stdlib.add(v10837, v10836);
          const v10839 = stdlib.sub(v958, v10838);
          const v10841 = stdlib.add(v10839, v10837);
          const v10842 = stdlib.add(v10841, v10836);
          const v10843 = stdlib.sub(v958, v10842);
          sim_r.txns.push({
            amt: v10842,
            kind: 'from',
            to: v948,
            tok: v910
            });
          if (v1024) {
            sim_r.isHalt = false;
            }
          else {
            const v10850 = stdlib.sub(v1125, v1125);
            sim_r.txns.push({
              amt: v1125,
              kind: 'from',
              to: v899,
              tok: v909
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_close0': {
          const v1198 = v1093[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1300 = v1093[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1402 = v1093[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1504 = v1093[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
  switch (v1093[0]) {
    case 'Bid_claim0': {
      const v1096 = v1093[1];
      ;
      ;
      undefined;
      const v1118 = stdlib.addressEq(v1092, v900);
      const v1120 = v1118 ? v1024 : false;
      stdlib.assert(v1120, {
        at: './donate.rsh:262:18:application',
        fs: ['at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
        msg: null,
        who: 'Bid_claim'
        });
      const v1125 = stdlib.sub(v957, v957);
      ;
      const v1126 = null;
      const v1127 = await txn1.getOutput('api', 'v1126', ctc3, v1126);
      if (v689) {
        stdlib.protect(ctc3, await interact.out(v1096, v1127), {
          at: './donate.rsh:256:12:application',
          fs: ['at ./donate.rsh:256:12:application call to [unknown function] (defined at: ./donate.rsh:256:12:function exp)', 'at ./donate.rsh:266:12:application call to "k" (defined at: ./donate.rsh:261:9:function exp)', 'at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
          msg: 'out',
          who: 'Bid_claim'
          });
        }
      else {
        }
      
      const v10815 = v946;
      const v10816 = v947;
      const v10817 = v948;
      const v10821 = v956;
      const v10822 = v1125;
      const v10830 = stdlib.add(v946, v905);
      const v10831 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v10832 = stdlib.mul(v10831, v906);
      const v10833 = stdlib.add(v946, v10832);
      const v10834 = stdlib.gt(v10830, v10833);
      const v10835 = v10834 ? v10830 : v10833;
      const v10836 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
      const v10837 = stdlib.mul(v902, v10836);
      const v10838 = stdlib.add(v10837, v10836);
      const v10839 = stdlib.sub(v958, v10838);
      const v10841 = stdlib.add(v10839, v10837);
      const v10842 = stdlib.add(v10841, v10836);
      const v10843 = stdlib.sub(v958, v10842);
      ;
      if (v1024) {
        return;
        }
      else {
        const v10850 = stdlib.sub(v1125, v1125);
        ;
        return;
        }
      break;
      }
    case 'Bid_close0': {
      const v1198 = v1093[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1300 = v1093[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1402 = v1093[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1504 = v1093[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_close(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc4,
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1031 = stdlib.protect(ctc4, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:277:11:application call to [unknown function] (defined at: ./donate.rsh:277:11:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_close0" (defined at: ./donate.rsh:277:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: 'in',
    who: 'Bid_close'
    });
  
  const v1048 = ['Bid_close0', v1031];
  
  const txn1 = await (ctc.sendrecv({
    args: [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978, v1048],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:278:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:278:22:decimal', stdlib.UInt_max, 0), v910]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
      
      switch (v1093[0]) {
        case 'Bid_claim0': {
          const v1096 = v1093[1];
          
          break;
          }
        case 'Bid_close0': {
          const v1198 = v1093[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:278:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:278:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v910
            });
          undefined;
          const v1237 = null;
          const v1238 = await txn1.getOutput('api', 'v1237', ctc3, v1237);
          
          const v1244 = stdlib.lt(v953, v947);
          const v11067 = v946;
          const v11068 = v947;
          const v11069 = v948;
          const v11072 = v1095;
          const v11073 = v956;
          const v11074 = v957;
          const v11075 = v958;
          if (v1244) {
            const v11076 = stdlib.add(v946, v905);
            const v11077 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v11078 = stdlib.mul(v11077, v906);
            const v11079 = stdlib.add(v946, v11078);
            const v11080 = stdlib.gt(v11076, v11079);
            const v11081 = v11080 ? v11076 : v11079;
            sim_r.isHalt = false;
            }
          else {
            const v11082 = stdlib.add(v946, v905);
            const v11083 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v11084 = stdlib.mul(v11083, v906);
            const v11085 = stdlib.add(v946, v11084);
            const v11086 = stdlib.gt(v11082, v11085);
            const v11087 = v11086 ? v11082 : v11085;
            const v11088 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
            const v11089 = stdlib.mul(v902, v11088);
            const v11090 = stdlib.add(v11089, v11088);
            const v11091 = stdlib.sub(v958, v11090);
            const v11092 = stdlib.ge(v946, v903);
            const v11093 = stdlib.add(v11091, v11089);
            const v11094 = stdlib.add(v11093, v11088);
            const v11095 = stdlib.sub(v958, v11094);
            sim_r.txns.push({
              amt: v11094,
              kind: 'from',
              to: v948,
              tok: v910
              });
            if (v11092) {
              sim_r.isHalt = false;
              }
            else {
              const v11102 = stdlib.sub(v957, v957);
              sim_r.txns.push({
                amt: v957,
                kind: 'from',
                to: v899,
                tok: v909
                });
              sim_r.isHalt = false;
              }}
          break;
          }
        case 'Bid_getBid0': {
          const v1300 = v1093[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1402 = v1093[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1504 = v1093[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
  switch (v1093[0]) {
    case 'Bid_claim0': {
      const v1096 = v1093[1];
      return;
      break;
      }
    case 'Bid_close0': {
      const v1198 = v1093[1];
      ;
      ;
      undefined;
      const v1237 = null;
      const v1238 = await txn1.getOutput('api', 'v1237', ctc3, v1237);
      if (v689) {
        stdlib.protect(ctc3, await interact.out(v1198, v1238), {
          at: './donate.rsh:277:12:application',
          fs: ['at ./donate.rsh:277:12:application call to [unknown function] (defined at: ./donate.rsh:277:12:function exp)', 'at ./donate.rsh:280:12:application call to "k" (defined at: ./donate.rsh:279:9:function exp)', 'at ./donate.rsh:279:9:application call to [unknown function] (defined at: ./donate.rsh:279:9:function exp)'],
          msg: 'out',
          who: 'Bid_close'
          });
        }
      else {
        }
      
      const v1244 = stdlib.lt(v953, v947);
      const v11067 = v946;
      const v11068 = v947;
      const v11069 = v948;
      const v11072 = v1095;
      const v11073 = v956;
      const v11074 = v957;
      const v11075 = v958;
      if (v1244) {
        const v11076 = stdlib.add(v946, v905);
        const v11077 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v11078 = stdlib.mul(v11077, v906);
        const v11079 = stdlib.add(v946, v11078);
        const v11080 = stdlib.gt(v11076, v11079);
        const v11081 = v11080 ? v11076 : v11079;
        return;
        }
      else {
        const v11082 = stdlib.add(v946, v905);
        const v11083 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v11084 = stdlib.mul(v11083, v906);
        const v11085 = stdlib.add(v946, v11084);
        const v11086 = stdlib.gt(v11082, v11085);
        const v11087 = v11086 ? v11082 : v11085;
        const v11088 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
        const v11089 = stdlib.mul(v902, v11088);
        const v11090 = stdlib.add(v11089, v11088);
        const v11091 = stdlib.sub(v958, v11090);
        const v11092 = stdlib.ge(v946, v903);
        const v11093 = stdlib.add(v11091, v11089);
        const v11094 = stdlib.add(v11093, v11088);
        const v11095 = stdlib.sub(v958, v11094);
        ;
        if (v11092) {
          return;
          }
        else {
          const v11102 = stdlib.sub(v957, v957);
          ;
          return;
          }}
      break;
      }
    case 'Bid_getBid0': {
      const v1300 = v1093[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1402 = v1093[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1504 = v1093[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getBid(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc5,
    Bid_close0: ctc5,
    Bid_getBid0: ctc3,
    Bid_getPurchase0: ctc3,
    Bid_touch0: ctc5
    });
  
  
  const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v989 = stdlib.protect(ctc3, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:206:9:application call to [unknown function] (defined at: ./donate.rsh:206:9:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_getBid0" (defined at: ./donate.rsh:205:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: 'in',
    who: 'Bid_getBid'
    });
  const v990 = v989[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
  const v992 = stdlib.lt(v953, v947);
  const v999 = stdlib.ge(v990, v978);
  const v1000 = v992 ? v999 : false;
  const v1001 = stdlib.ge(v990, v904);
  const v1002 = v1000 ? v1001 : false;
  stdlib.assert(v1002, {
    at: './donate.rsh:206:25:application',
    fs: ['at ./donate.rsh:206:9:application call to [unknown function] (defined at: ./donate.rsh:206:16:function exp)', 'at ./donate.rsh:206:9:application call to [unknown function] (defined at: ./donate.rsh:206:9:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_getBid0" (defined at: ./donate.rsh:205:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: null,
    who: 'Bid_getBid'
    });
  
  const v1059 = ['Bid_getBid0', v989];
  
  const txn1 = await (ctc.sendrecv({
    args: [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978, v1059],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:210:20:decimal', stdlib.UInt_max, 0), [[v990, v910]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
      
      switch (v1093[0]) {
        case 'Bid_claim0': {
          const v1096 = v1093[1];
          
          break;
          }
        case 'Bid_close0': {
          const v1198 = v1093[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1300 = v1093[1];
          const v1301 = v1300[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:210:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1319 = stdlib.add(v958, v1301);
          sim_r.txns.push({
            amt: v1301,
            kind: 'to',
            tok: v910
            });
          undefined;
          const v1358 = stdlib.ge(v1301, v978);
          const v1359 = v992 ? v1358 : false;
          const v1360 = stdlib.ge(v1301, v904);
          const v1361 = v1359 ? v1360 : false;
          stdlib.assert(v1361, {
            at: './donate.rsh:212:18:application',
            fs: ['at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
            msg: null,
            who: 'Bid_getBid'
            });
          const v1365 = stdlib.sub(v1319, v946);
          sim_r.txns.push({
            amt: v946,
            kind: 'from',
            to: v948,
            tok: v910
            });
          const v1366 = null;
          const v1367 = await txn1.getOutput('api', 'v1366', ctc4, v1366);
          
          const v1372 = stdlib.add(v947, stdlib.checkedBigNumberify('./donate.rsh:161:33:decimal', stdlib.UInt_max, 60));
          const v11319 = v1301;
          const v11320 = v1372;
          const v11321 = v1092;
          const v11324 = v1095;
          const v11325 = v956;
          const v11326 = v957;
          const v11327 = v1365;
          const v11328 = stdlib.add(v1301, v905);
          const v11329 = stdlib.div(v1301, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v11330 = stdlib.mul(v11329, v906);
          const v11331 = stdlib.add(v1301, v11330);
          const v11332 = stdlib.gt(v11328, v11331);
          const v11333 = v11332 ? v11328 : v11331;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1402 = v1093[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1504 = v1093[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
  switch (v1093[0]) {
    case 'Bid_claim0': {
      const v1096 = v1093[1];
      return;
      break;
      }
    case 'Bid_close0': {
      const v1198 = v1093[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1300 = v1093[1];
      const v1301 = v1300[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1319 = stdlib.add(v958, v1301);
      ;
      undefined;
      const v1358 = stdlib.ge(v1301, v978);
      const v1359 = v992 ? v1358 : false;
      const v1360 = stdlib.ge(v1301, v904);
      const v1361 = v1359 ? v1360 : false;
      stdlib.assert(v1361, {
        at: './donate.rsh:212:18:application',
        fs: ['at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
        msg: null,
        who: 'Bid_getBid'
        });
      const v1365 = stdlib.sub(v1319, v946);
      ;
      const v1366 = null;
      const v1367 = await txn1.getOutput('api', 'v1366', ctc4, v1366);
      if (v689) {
        stdlib.protect(ctc4, await interact.out(v1300, v1367), {
          at: './donate.rsh:205:12:application',
          fs: ['at ./donate.rsh:205:12:application call to [unknown function] (defined at: ./donate.rsh:205:12:function exp)', 'at ./donate.rsh:217:12:application call to "k" (defined at: ./donate.rsh:211:9:function exp)', 'at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
          msg: 'out',
          who: 'Bid_getBid'
          });
        }
      else {
        }
      
      const v1372 = stdlib.add(v947, stdlib.checkedBigNumberify('./donate.rsh:161:33:decimal', stdlib.UInt_max, 60));
      const v11319 = v1301;
      const v11320 = v1372;
      const v11321 = v1092;
      const v11324 = v1095;
      const v11325 = v956;
      const v11326 = v957;
      const v11327 = v1365;
      const v11328 = stdlib.add(v1301, v905);
      const v11329 = stdlib.div(v1301, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v11330 = stdlib.mul(v11329, v906);
      const v11331 = stdlib.add(v1301, v11330);
      const v11332 = stdlib.gt(v11328, v11331);
      const v11333 = v11332 ? v11328 : v11331;
      return;
      
      break;
      }
    case 'Bid_getPurchase0': {
      const v1402 = v1093[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1504 = v1093[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getPurchase(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc5,
    Bid_close0: ctc5,
    Bid_getBid0: ctc3,
    Bid_getPurchase0: ctc3,
    Bid_touch0: ctc5
    });
  
  
  const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1008 = stdlib.protect(ctc3, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:231:9:application call to [unknown function] (defined at: ./donate.rsh:231:9:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_getPurchase0" (defined at: ./donate.rsh:230:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: 'in',
    who: 'Bid_getPurchase'
    });
  const v1009 = v1008[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
  const v1011 = stdlib.ge(v953, v947);
  const v1012 = stdlib.lt(v946, v903);
  const v1013 = v1011 ? v1012 : false;
  const v1014 = stdlib.ge(v1009, v903);
  const v1015 = v1013 ? v1014 : false;
  stdlib.assert(v1015, {
    at: './donate.rsh:231:25:application',
    fs: ['at ./donate.rsh:231:9:application call to [unknown function] (defined at: ./donate.rsh:231:16:function exp)', 'at ./donate.rsh:231:9:application call to [unknown function] (defined at: ./donate.rsh:231:9:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_getPurchase0" (defined at: ./donate.rsh:230:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: null,
    who: 'Bid_getPurchase'
    });
  
  const v1070 = ['Bid_getPurchase0', v1008];
  
  const txn1 = await (ctc.sendrecv({
    args: [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978, v1070],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:236:20:decimal', stdlib.UInt_max, 0), [[v1009, v910]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
      
      switch (v1093[0]) {
        case 'Bid_claim0': {
          const v1096 = v1093[1];
          
          break;
          }
        case 'Bid_close0': {
          const v1198 = v1093[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1300 = v1093[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1402 = v1093[1];
          const v1403 = v1402[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:236:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1421 = stdlib.add(v958, v1403);
          sim_r.txns.push({
            amt: v1403,
            kind: 'to',
            tok: v910
            });
          undefined;
          const v1482 = stdlib.ge(v1403, v903);
          const v1483 = v1013 ? v1482 : false;
          stdlib.assert(v1483, {
            at: './donate.rsh:238:18:application',
            fs: ['at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
            msg: null,
            who: 'Bid_getPurchase'
            });
          const v1487 = stdlib.sub(v1421, v946);
          sim_r.txns.push({
            amt: v946,
            kind: 'from',
            to: v948,
            tok: v910
            });
          const v1488 = null;
          const v1489 = await txn1.getOutput('api', 'v1488', ctc4, v1488);
          
          const v11571 = v1403;
          const v11572 = v947;
          const v11573 = v1092;
          const v11577 = v956;
          const v11578 = v957;
          const v11586 = stdlib.add(v1403, v905);
          const v11587 = stdlib.div(v1403, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v11588 = stdlib.mul(v11587, v906);
          const v11589 = stdlib.add(v1403, v11588);
          const v11590 = stdlib.gt(v11586, v11589);
          const v11591 = v11590 ? v11586 : v11589;
          const v11592 = stdlib.div(v1487, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
          const v11593 = stdlib.mul(v902, v11592);
          const v11594 = stdlib.add(v11593, v11592);
          const v11595 = stdlib.sub(v1487, v11594);
          const v11597 = stdlib.add(v11595, v11593);
          const v11598 = stdlib.add(v11597, v11592);
          const v11599 = stdlib.sub(v1487, v11598);
          sim_r.txns.push({
            amt: v11598,
            kind: 'from',
            to: v1092,
            tok: v910
            });
          if (v1482) {
            sim_r.isHalt = false;
            }
          else {
            const v11606 = stdlib.sub(v957, v957);
            sim_r.txns.push({
              amt: v957,
              kind: 'from',
              to: v899,
              tok: v909
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_touch0': {
          const v1504 = v1093[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
  switch (v1093[0]) {
    case 'Bid_claim0': {
      const v1096 = v1093[1];
      return;
      break;
      }
    case 'Bid_close0': {
      const v1198 = v1093[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1300 = v1093[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1402 = v1093[1];
      const v1403 = v1402[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1421 = stdlib.add(v958, v1403);
      ;
      undefined;
      const v1482 = stdlib.ge(v1403, v903);
      const v1483 = v1013 ? v1482 : false;
      stdlib.assert(v1483, {
        at: './donate.rsh:238:18:application',
        fs: ['at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
        msg: null,
        who: 'Bid_getPurchase'
        });
      const v1487 = stdlib.sub(v1421, v946);
      ;
      const v1488 = null;
      const v1489 = await txn1.getOutput('api', 'v1488', ctc4, v1488);
      if (v689) {
        stdlib.protect(ctc4, await interact.out(v1402, v1489), {
          at: './donate.rsh:230:12:application',
          fs: ['at ./donate.rsh:230:12:application call to [unknown function] (defined at: ./donate.rsh:230:12:function exp)', 'at ./donate.rsh:244:12:application call to "k" (defined at: ./donate.rsh:237:9:function exp)', 'at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
          msg: 'out',
          who: 'Bid_getPurchase'
          });
        }
      else {
        }
      
      const v11571 = v1403;
      const v11572 = v947;
      const v11573 = v1092;
      const v11577 = v956;
      const v11578 = v957;
      const v11586 = stdlib.add(v1403, v905);
      const v11587 = stdlib.div(v1403, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v11588 = stdlib.mul(v11587, v906);
      const v11589 = stdlib.add(v1403, v11588);
      const v11590 = stdlib.gt(v11586, v11589);
      const v11591 = v11590 ? v11586 : v11589;
      const v11592 = stdlib.div(v1487, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
      const v11593 = stdlib.mul(v902, v11592);
      const v11594 = stdlib.add(v11593, v11592);
      const v11595 = stdlib.sub(v1487, v11594);
      const v11597 = stdlib.add(v11595, v11593);
      const v11598 = stdlib.add(v11597, v11592);
      const v11599 = stdlib.sub(v1487, v11598);
      ;
      if (v1482) {
        return;
        }
      else {
        const v11606 = stdlib.sub(v957, v957);
        ;
        return;
        }
      break;
      }
    case 'Bid_touch0': {
      const v1504 = v1093[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_touch(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc4,
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v981 = stdlib.protect(ctc4, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:189:11:application call to [unknown function] (defined at: ./donate.rsh:189:11:function exp)', 'at ./donate.rsh:170:19:application call to "runBid_touch0" (defined at: ./donate.rsh:189:11:function exp)', 'at ./donate.rsh:170:19:application call to [unknown function] (defined at: ./donate.rsh:170:19:function exp)'],
    msg: 'in',
    who: 'Bid_touch'
    });
  
  const v1081 = ['Bid_touch0', v981];
  
  const txn1 = await (ctc.sendrecv({
    args: [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v946, v947, v948, v953, v956, v957, v958, v978, v1081],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:190:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:190:22:decimal', stdlib.UInt_max, 0), v910]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
      
      switch (v1093[0]) {
        case 'Bid_claim0': {
          const v1096 = v1093[1];
          
          break;
          }
        case 'Bid_close0': {
          const v1198 = v1093[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1300 = v1093[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1402 = v1093[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1504 = v1093[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:190:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:190:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v910
            });
          undefined;
          const v1599 = null;
          const v1600 = await txn1.getOutput('api', 'v1599', ctc3, v1599);
          
          const v11823 = v946;
          const v11824 = v947;
          const v11825 = v948;
          const v11828 = v1095;
          const v11829 = v956;
          const v11830 = v957;
          const v11831 = v958;
          const v11832 = stdlib.add(v946, v905);
          const v11833 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v11834 = stdlib.mul(v11833, v906);
          const v11835 = stdlib.add(v946, v11834);
          const v11836 = stdlib.gt(v11832, v11835);
          const v11837 = v11836 ? v11832 : v11835;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn1;
  switch (v1093[0]) {
    case 'Bid_claim0': {
      const v1096 = v1093[1];
      return;
      break;
      }
    case 'Bid_close0': {
      const v1198 = v1093[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1300 = v1093[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1402 = v1093[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1504 = v1093[1];
      ;
      ;
      undefined;
      const v1599 = null;
      const v1600 = await txn1.getOutput('api', 'v1599', ctc3, v1599);
      if (v689) {
        stdlib.protect(ctc3, await interact.out(v1504, v1600), {
          at: './donate.rsh:189:12:application',
          fs: ['at ./donate.rsh:189:12:application call to [unknown function] (defined at: ./donate.rsh:189:12:function exp)', 'at ./donate.rsh:192:12:application call to "k" (defined at: ./donate.rsh:191:9:function exp)', 'at ./donate.rsh:191:9:application call to [unknown function] (defined at: ./donate.rsh:191:9:function exp)'],
          msg: 'out',
          who: 'Bid_touch'
          });
        }
      else {
        }
      
      const v11823 = v946;
      const v11824 = v947;
      const v11825 = v948;
      const v11828 = v1095;
      const v11829 = v956;
      const v11830 = v957;
      const v11831 = v958;
      const v11832 = stdlib.add(v946, v905);
      const v11833 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v11834 = stdlib.mul(v11833, v906);
      const v11835 = stdlib.add(v946, v11834);
      const v11836 = stdlib.gt(v11832, v11835);
      const v11837 = v11836 ? v11832 : v11835;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0
    });
  const ctc2 = stdlib.T_Null;
  const ctc3 = stdlib.T_UInt;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Tuple([ctc2]);
  const ctc6 = stdlib.T_Tuple([ctc3]);
  const ctc7 = stdlib.T_Data({
    Bid_claim0: ctc5,
    Bid_close0: ctc5,
    Bid_getBid0: ctc6,
    Bid_getPurchase0: ctc6,
    Bid_touch0: ctc5
    });
  
  
  const v858 = stdlib.protect(ctc1, await interact.getParams(), {
    at: './util.rsh:43:38:application',
    fs: ['at ./util.rsh:37:19:application call to [unknown function] (defined at: ./util.rsh:37:23:function exp)', 'at ./donate.rsh:77:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v859 = v858.addr;
  const v860 = v858.addr2;
  const v861 = v858.addr3;
  const v862 = v858.addr4;
  
  const txn1 = await (ctc.sendrecv({
    args: [v859, v860, v861, v862],
    evt_cnt: 4,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./util.rsh:47:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    pay: [stdlib.checkedBigNumberify('./util.rsh:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v864, v865, v866, v867], secs: v869, time: v868, didSend: v32, from: v863 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./util.rsh:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v871 = v867;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [v864, v865, v866, v867], secs: v869, time: v868, didSend: v32, from: v863 } = txn1;
  ;
  const v871 = v867;
  stdlib.protect(ctc2, await interact.signal(), {
    at: './util.rsh:55:41:application',
    fs: ['at ./util.rsh:55:19:application call to [unknown function] (defined at: ./util.rsh:55:23:function exp)', 'at ./donate.rsh:77:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 14,
    funcNum: 1,
    out_tys: [ctc0, ctc0, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc4, ctc4, ctc3, ctc3, ctc3],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v900, v901, v902, v903, v904, v905, v906, v907, v908, v909, v910, v911, v912, v913], secs: v915, time: v914, didSend: v85, from: v899 } = txn2;
  const v916 = stdlib.tokenEq(v909, v910);
  const v917 = v916 ? false : true;
  stdlib.assert(v917, {
    at: './donate.rsh:106:6:dot',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  ;
  ;
  ;
  stdlib.assert(v917, {
    at: './donate.rsh:124:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v922 = stdlib.ge(v902, stdlib.checkedBigNumberify('./donate.rsh:125:27:decimal', stdlib.UInt_max, 0));
  const v923 = stdlib.le(v902, stdlib.checkedBigNumberify('./donate.rsh:125:48:decimal', stdlib.UInt_max, 99));
  const v924 = v922 ? v923 : false;
  stdlib.assert(v924, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v925 = stdlib.ge(v904, stdlib.checkedBigNumberify('./donate.rsh:126:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v925, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v926 = stdlib.lt(v904, v903);
  stdlib.assert(v926, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v930 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:130:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v934 = stdlib.sub(v930, stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v935 = v899;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v938, time: v937, didSend: v110, from: v936 } = txn3;
  ;
  ;
  const v942 = stdlib.addressEq(v935, v936);
  stdlib.assert(v942, {
    at: './donate.rsh:137:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Constructor'
    });
  let v946 = stdlib.checkedBigNumberify('./donate.rsh:173:24:decimal', stdlib.UInt_max, 0);
  let v947 = v913;
  let v948 = v899;
  let v949 = true;
  let v950 = v937;
  let v953 = v938;
  let v956 = v934;
  let v957 = stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1);
  let v958 = stdlib.checkedBigNumberify('./donate.rsh:106:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v949;})()) {
    const v973 = stdlib.add(v946, v905);
    const v974 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v975 = stdlib.mul(v974, v906);
    const v976 = stdlib.add(v946, v975);
    const v977 = stdlib.gt(v973, v976);
    const v978 = v977 ? v973 : v976;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn4;
    switch (v1093[0]) {
      case 'Bid_claim0': {
        const v1096 = v1093[1];
        ;
        ;
        undefined;
        const v1118 = stdlib.addressEq(v1092, v900);
        const v1119 = stdlib.ge(v946, v903);
        const v1120 = v1118 ? v1119 : false;
        stdlib.assert(v1120, {
          at: './donate.rsh:262:18:application',
          fs: ['at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1125 = stdlib.sub(v957, v957);
        ;
        const v1126 = null;
        await txn4.getOutput('api', 'v1126', ctc2, v1126);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v1125;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_close0': {
        const v1198 = v1093[1];
        ;
        ;
        undefined;
        const v1237 = null;
        await txn4.getOutput('api', 'v1237', ctc2, v1237);
        const v1244 = stdlib.lt(v953, v947);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = v1244;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1300 = v1093[1];
        const v1301 = v1300[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1319 = stdlib.add(v958, v1301);
        ;
        undefined;
        const v1351 = stdlib.lt(v953, v947);
        const v1358 = stdlib.ge(v1301, v978);
        const v1359 = v1351 ? v1358 : false;
        const v1360 = stdlib.ge(v1301, v904);
        const v1361 = v1359 ? v1360 : false;
        stdlib.assert(v1361, {
          at: './donate.rsh:212:18:application',
          fs: ['at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1365 = stdlib.sub(v1319, v946);
        ;
        const v1366 = null;
        await txn4.getOutput('api', 'v1366', ctc2, v1366);
        const v1372 = stdlib.add(v947, stdlib.checkedBigNumberify('./donate.rsh:161:33:decimal', stdlib.UInt_max, 60));
        const cv946 = v1301;
        const cv947 = v1372;
        const cv948 = v1092;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1365;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1402 = v1093[1];
        const v1403 = v1402[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1421 = stdlib.add(v958, v1403);
        ;
        undefined;
        const v1479 = stdlib.ge(v953, v947);
        const v1480 = stdlib.lt(v946, v903);
        const v1481 = v1479 ? v1480 : false;
        const v1482 = stdlib.ge(v1403, v903);
        const v1483 = v1481 ? v1482 : false;
        stdlib.assert(v1483, {
          at: './donate.rsh:238:18:application',
          fs: ['at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1487 = stdlib.sub(v1421, v946);
        ;
        const v1488 = null;
        await txn4.getOutput('api', 'v1488', ctc2, v1488);
        const cv946 = v1403;
        const cv947 = v947;
        const cv948 = v1092;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1487;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1504 = v1093[1];
        ;
        ;
        undefined;
        const v1599 = null;
        await txn4.getOutput('api', 'v1599', ctc2, v1599);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      }
    
    }
  const v1606 = stdlib.add(v946, v905);
  const v1607 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1608 = stdlib.mul(v1607, v906);
  const v1609 = stdlib.add(v946, v1608);
  const v1610 = stdlib.gt(v1606, v1609);
  const v1611 = v1610 ? v1606 : v1609;
  const v1613 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
  const v1614 = stdlib.mul(v902, v1613);
  const v1616 = stdlib.add(v1614, v1613);
  const v1617 = stdlib.sub(v958, v1616);
  const v1618 = stdlib.ge(v946, v903);
  const v1619 = stdlib.add(v1617, v1614);
  const v1620 = stdlib.add(v1619, v1613);
  const v1624 = stdlib.sub(v958, v1620);
  ;
  if (v1618) {
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1628, time: v1627, didSend: v817, from: v1626 } = txn4;
    ;
    const v1630 = stdlib.addressEq(v871, v1626);
    stdlib.assert(v1630, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1618) {
      const v1635 = stdlib.sub(v957, v957);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1684 = stdlib.sub(v957, v957);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1688, time: v1687, didSend: v817, from: v1686 } = txn4;
    ;
    const v1690 = stdlib.addressEq(v871, v1686);
    stdlib.assert(v1690, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1618) {
      const v1695 = stdlib.sub(v1684, v1684);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Depositer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Depositer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Depositer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc4,
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v864, v865, v866, v867], secs: v869, time: v868, didSend: v32, from: v863 } = txn1;
  ;
  const v871 = v867;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 14,
    funcNum: 1,
    out_tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v900, v901, v902, v903, v904, v905, v906, v907, v908, v909, v910, v911, v912, v913], secs: v915, time: v914, didSend: v85, from: v899 } = txn2;
  const v916 = stdlib.tokenEq(v909, v910);
  const v917 = v916 ? false : true;
  stdlib.assert(v917, {
    at: './donate.rsh:106:6:dot',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  ;
  ;
  ;
  stdlib.assert(v917, {
    at: './donate.rsh:124:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v922 = stdlib.ge(v902, stdlib.checkedBigNumberify('./donate.rsh:125:27:decimal', stdlib.UInt_max, 0));
  const v923 = stdlib.le(v902, stdlib.checkedBigNumberify('./donate.rsh:125:48:decimal', stdlib.UInt_max, 99));
  const v924 = v922 ? v923 : false;
  stdlib.assert(v924, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v925 = stdlib.ge(v904, stdlib.checkedBigNumberify('./donate.rsh:126:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v925, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v926 = stdlib.lt(v904, v903);
  stdlib.assert(v926, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v930 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:130:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v934 = stdlib.sub(v930, stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v935 = ctc.iam(v899);
  const txn3 = await (ctc.sendrecv({
    args: [v865, v867, v871, v899, v900, v902, v903, v904, v905, v906, v909, v910, v913, v934, v935],
    evt_cnt: 0,
    funcNum: 2,
    lct: v914,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:137:11:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1), v909]]],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [], secs: v938, time: v937, didSend: v110, from: v936 } = txn3;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:137:11:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1),
        kind: 'to',
        tok: v909
        });
      const v942 = stdlib.addressEq(v935, v936);
      stdlib.assert(v942, {
        at: './donate.rsh:137:6:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Depositer'
        });
      
      const v946 = stdlib.checkedBigNumberify('./donate.rsh:173:24:decimal', stdlib.UInt_max, 0);
      const v947 = v913;
      const v948 = v899;
      const v949 = true;
      const v950 = v937;
      const v953 = v938;
      const v956 = v934;
      const v957 = stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1);
      const v958 = stdlib.checkedBigNumberify('./donate.rsh:106:6:dot', stdlib.UInt_max, 0);
      
      if (await (async () => {
        
        return v949;})()) {
        const v973 = stdlib.add(v946, v905);
        const v974 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v975 = stdlib.mul(v974, v906);
        const v976 = stdlib.add(v946, v975);
        const v977 = stdlib.gt(v973, v976);
        const v978 = v977 ? v973 : v976;
        sim_r.isHalt = false;
        }
      else {
        const v1606 = stdlib.add(v946, v905);
        const v1607 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v1608 = stdlib.mul(v1607, v906);
        const v1609 = stdlib.add(v946, v1608);
        const v1610 = stdlib.gt(v1606, v1609);
        const v1611 = v1610 ? v1606 : v1609;
        const v1613 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
        const v1614 = stdlib.mul(v902, v1613);
        const v1616 = stdlib.add(v1614, v1613);
        const v1617 = stdlib.sub(v958, v1616);
        const v1618 = stdlib.ge(v946, v903);
        const v1619 = stdlib.add(v1617, v1614);
        const v1620 = stdlib.add(v1619, v1613);
        const v1624 = stdlib.sub(v958, v1620);
        sim_r.txns.push({
          amt: v1620,
          kind: 'from',
          to: v948,
          tok: v910
          });
        if (v1618) {
          sim_r.isHalt = false;
          }
        else {
          const v1684 = stdlib.sub(v957, v957);
          sim_r.txns.push({
            amt: v957,
            kind: 'from',
            to: v899,
            tok: v909
            });
          sim_r.isHalt = false;
          }}
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v938, time: v937, didSend: v110, from: v936 } = txn3;
  ;
  ;
  const v942 = stdlib.addressEq(v935, v936);
  stdlib.assert(v942, {
    at: './donate.rsh:137:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Depositer'
    });
  stdlib.protect(ctc3, await interact.signal(), {
    at: './donate.rsh:139:39:application',
    fs: ['at ./donate.rsh:139:17:application call to [unknown function] (defined at: ./donate.rsh:139:21:function exp)'],
    msg: 'signal',
    who: 'Depositer'
    });
  
  let v946 = stdlib.checkedBigNumberify('./donate.rsh:173:24:decimal', stdlib.UInt_max, 0);
  let v947 = v913;
  let v948 = v899;
  let v949 = true;
  let v950 = v937;
  let v953 = v938;
  let v956 = v934;
  let v957 = stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1);
  let v958 = stdlib.checkedBigNumberify('./donate.rsh:106:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v949;})()) {
    const v973 = stdlib.add(v946, v905);
    const v974 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v975 = stdlib.mul(v974, v906);
    const v976 = stdlib.add(v946, v975);
    const v977 = stdlib.gt(v973, v976);
    const v978 = v977 ? v973 : v976;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn4;
    switch (v1093[0]) {
      case 'Bid_claim0': {
        const v1096 = v1093[1];
        ;
        ;
        undefined;
        const v1118 = stdlib.addressEq(v1092, v900);
        const v1119 = stdlib.ge(v946, v903);
        const v1120 = v1118 ? v1119 : false;
        stdlib.assert(v1120, {
          at: './donate.rsh:262:18:application',
          fs: ['at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1125 = stdlib.sub(v957, v957);
        ;
        const v1126 = null;
        await txn4.getOutput('api', 'v1126', ctc3, v1126);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v1125;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_close0': {
        const v1198 = v1093[1];
        ;
        ;
        undefined;
        const v1237 = null;
        await txn4.getOutput('api', 'v1237', ctc3, v1237);
        const v1244 = stdlib.lt(v953, v947);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = v1244;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1300 = v1093[1];
        const v1301 = v1300[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1319 = stdlib.add(v958, v1301);
        ;
        undefined;
        const v1351 = stdlib.lt(v953, v947);
        const v1358 = stdlib.ge(v1301, v978);
        const v1359 = v1351 ? v1358 : false;
        const v1360 = stdlib.ge(v1301, v904);
        const v1361 = v1359 ? v1360 : false;
        stdlib.assert(v1361, {
          at: './donate.rsh:212:18:application',
          fs: ['at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1365 = stdlib.sub(v1319, v946);
        ;
        const v1366 = null;
        await txn4.getOutput('api', 'v1366', ctc3, v1366);
        const v1372 = stdlib.add(v947, stdlib.checkedBigNumberify('./donate.rsh:161:33:decimal', stdlib.UInt_max, 60));
        const cv946 = v1301;
        const cv947 = v1372;
        const cv948 = v1092;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1365;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1402 = v1093[1];
        const v1403 = v1402[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1421 = stdlib.add(v958, v1403);
        ;
        undefined;
        const v1479 = stdlib.ge(v953, v947);
        const v1480 = stdlib.lt(v946, v903);
        const v1481 = v1479 ? v1480 : false;
        const v1482 = stdlib.ge(v1403, v903);
        const v1483 = v1481 ? v1482 : false;
        stdlib.assert(v1483, {
          at: './donate.rsh:238:18:application',
          fs: ['at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1487 = stdlib.sub(v1421, v946);
        ;
        const v1488 = null;
        await txn4.getOutput('api', 'v1488', ctc3, v1488);
        const cv946 = v1403;
        const cv947 = v947;
        const cv948 = v1092;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1487;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1504 = v1093[1];
        ;
        ;
        undefined;
        const v1599 = null;
        await txn4.getOutput('api', 'v1599', ctc3, v1599);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      }
    
    }
  const v1606 = stdlib.add(v946, v905);
  const v1607 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1608 = stdlib.mul(v1607, v906);
  const v1609 = stdlib.add(v946, v1608);
  const v1610 = stdlib.gt(v1606, v1609);
  const v1611 = v1610 ? v1606 : v1609;
  const v1613 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
  const v1614 = stdlib.mul(v902, v1613);
  const v1616 = stdlib.add(v1614, v1613);
  const v1617 = stdlib.sub(v958, v1616);
  const v1618 = stdlib.ge(v946, v903);
  const v1619 = stdlib.add(v1617, v1614);
  const v1620 = stdlib.add(v1619, v1613);
  const v1624 = stdlib.sub(v958, v1620);
  ;
  if (v1618) {
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1628, time: v1627, didSend: v817, from: v1626 } = txn4;
    ;
    const v1630 = stdlib.addressEq(v871, v1626);
    stdlib.assert(v1630, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1618) {
      const v1635 = stdlib.sub(v957, v957);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1684 = stdlib.sub(v957, v957);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1688, time: v1687, didSend: v817, from: v1686 } = txn4;
    ;
    const v1690 = stdlib.addressEq(v871, v1686);
    stdlib.assert(v1690, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1618) {
      const v1695 = stdlib.sub(v1684, v1684);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0: ctc4,
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  const ctc7 = stdlib.T_Bool;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v864, v865, v866, v867], secs: v869, time: v868, didSend: v32, from: v863 } = txn1;
  ;
  const v871 = ctc.iam(v867);
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 14,
    funcNum: 1,
    out_tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v900, v901, v902, v903, v904, v905, v906, v907, v908, v909, v910, v911, v912, v913], secs: v915, time: v914, didSend: v85, from: v899 } = txn2;
  const v916 = stdlib.tokenEq(v909, v910);
  const v917 = v916 ? false : true;
  stdlib.assert(v917, {
    at: './donate.rsh:106:6:dot',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  ;
  ;
  ;
  stdlib.assert(v917, {
    at: './donate.rsh:124:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v922 = stdlib.ge(v902, stdlib.checkedBigNumberify('./donate.rsh:125:27:decimal', stdlib.UInt_max, 0));
  const v923 = stdlib.le(v902, stdlib.checkedBigNumberify('./donate.rsh:125:48:decimal', stdlib.UInt_max, 99));
  const v924 = v922 ? v923 : false;
  stdlib.assert(v924, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v925 = stdlib.ge(v904, stdlib.checkedBigNumberify('./donate.rsh:126:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v925, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v926 = stdlib.lt(v904, v903);
  stdlib.assert(v926, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v930 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:123:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:130:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v934 = stdlib.sub(v930, stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v935 = v899;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v938, time: v937, didSend: v110, from: v936 } = txn3;
  ;
  ;
  const v942 = stdlib.addressEq(v935, v936);
  stdlib.assert(v942, {
    at: './donate.rsh:137:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Relay'
    });
  let v946 = stdlib.checkedBigNumberify('./donate.rsh:173:24:decimal', stdlib.UInt_max, 0);
  let v947 = v913;
  let v948 = v899;
  let v949 = true;
  let v950 = v937;
  let v953 = v938;
  let v956 = v934;
  let v957 = stdlib.checkedBigNumberify('./donate.rsh:137:15:decimal', stdlib.UInt_max, 1);
  let v958 = stdlib.checkedBigNumberify('./donate.rsh:106:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v949;})()) {
    const v973 = stdlib.add(v946, v905);
    const v974 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v975 = stdlib.mul(v974, v906);
    const v976 = stdlib.add(v946, v975);
    const v977 = stdlib.gt(v973, v976);
    const v978 = v977 ? v973 : v976;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1093], secs: v1095, time: v1094, didSend: v689, from: v1092 } = txn4;
    switch (v1093[0]) {
      case 'Bid_claim0': {
        const v1096 = v1093[1];
        ;
        ;
        undefined;
        const v1118 = stdlib.addressEq(v1092, v900);
        const v1119 = stdlib.ge(v946, v903);
        const v1120 = v1118 ? v1119 : false;
        stdlib.assert(v1120, {
          at: './donate.rsh:262:18:application',
          fs: ['at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1125 = stdlib.sub(v957, v957);
        ;
        const v1126 = null;
        await txn4.getOutput('api', 'v1126', ctc3, v1126);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v1125;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_close0': {
        const v1198 = v1093[1];
        ;
        ;
        undefined;
        const v1237 = null;
        await txn4.getOutput('api', 'v1237', ctc3, v1237);
        const v1244 = stdlib.lt(v953, v947);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = v1244;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1300 = v1093[1];
        const v1301 = v1300[stdlib.checkedBigNumberify('./donate.rsh:205:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1319 = stdlib.add(v958, v1301);
        ;
        undefined;
        const v1351 = stdlib.lt(v953, v947);
        const v1358 = stdlib.ge(v1301, v978);
        const v1359 = v1351 ? v1358 : false;
        const v1360 = stdlib.ge(v1301, v904);
        const v1361 = v1359 ? v1360 : false;
        stdlib.assert(v1361, {
          at: './donate.rsh:212:18:application',
          fs: ['at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1365 = stdlib.sub(v1319, v946);
        ;
        const v1366 = null;
        await txn4.getOutput('api', 'v1366', ctc3, v1366);
        const v1372 = stdlib.add(v947, stdlib.checkedBigNumberify('./donate.rsh:161:33:decimal', stdlib.UInt_max, 60));
        const cv946 = v1301;
        const cv947 = v1372;
        const cv948 = v1092;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1365;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1402 = v1093[1];
        const v1403 = v1402[stdlib.checkedBigNumberify('./donate.rsh:230:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1421 = stdlib.add(v958, v1403);
        ;
        undefined;
        const v1479 = stdlib.ge(v953, v947);
        const v1480 = stdlib.lt(v946, v903);
        const v1481 = v1479 ? v1480 : false;
        const v1482 = stdlib.ge(v1403, v903);
        const v1483 = v1481 ? v1482 : false;
        stdlib.assert(v1483, {
          at: './donate.rsh:238:18:application',
          fs: ['at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1487 = stdlib.sub(v1421, v946);
        ;
        const v1488 = null;
        await txn4.getOutput('api', 'v1488', ctc3, v1488);
        const cv946 = v1403;
        const cv947 = v947;
        const cv948 = v1092;
        const cv949 = false;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v1487;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1504 = v1093[1];
        ;
        ;
        undefined;
        const v1599 = null;
        await txn4.getOutput('api', 'v1599', ctc3, v1599);
        const cv946 = v946;
        const cv947 = v947;
        const cv948 = v948;
        const cv949 = true;
        const cv950 = v1094;
        const cv953 = v1095;
        const cv956 = v956;
        const cv957 = v957;
        const cv958 = v958;
        
        v946 = cv946;
        v947 = cv947;
        v948 = cv948;
        v949 = cv949;
        v950 = cv950;
        v953 = cv953;
        v956 = cv956;
        v957 = cv957;
        v958 = cv958;
        
        continue;
        break;
        }
      }
    
    }
  const v1606 = stdlib.add(v946, v905);
  const v1607 = stdlib.div(v946, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1608 = stdlib.mul(v1607, v906);
  const v1609 = stdlib.add(v946, v1608);
  const v1610 = stdlib.gt(v1606, v1609);
  const v1611 = v1610 ? v1606 : v1609;
  const v1613 = stdlib.div(v958, stdlib.checkedBigNumberify('./donate.rsh:298:34:decimal', stdlib.UInt_max, 100));
  const v1614 = stdlib.mul(v902, v1613);
  const v1616 = stdlib.add(v1614, v1613);
  const v1617 = stdlib.sub(v958, v1616);
  const v1618 = stdlib.ge(v946, v903);
  const v1619 = stdlib.add(v1617, v1614);
  const v1620 = stdlib.add(v1619, v1613);
  const v1624 = stdlib.sub(v958, v1620);
  ;
  if (v1618) {
    const txn4 = await (ctc.sendrecv({
      args: [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v957, v1611, v1618, v1624],
      evt_cnt: 0,
      funcNum: 4,
      lct: v950,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./donate.rsh:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
        
        const {data: [], secs: v1628, time: v1627, didSend: v817, from: v1626 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./donate.rsh:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1630 = stdlib.addressEq(v871, v1626);
        stdlib.assert(v1630, {
          at: './donate.rsh:334:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1618) {
          const v1635 = stdlib.sub(v957, v957);
          sim_r.txns.push({
            amt: v957,
            kind: 'from',
            to: v867,
            tok: v909
            });
          sim_r.txns.push({
            amt: v956,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1635,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1624,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v910
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v909
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v956,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v957,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1624,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v910
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v909
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc7, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1628, time: v1627, didSend: v817, from: v1626 } = txn4;
    ;
    const v1630 = stdlib.addressEq(v871, v1626);
    stdlib.assert(v1630, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1618) {
      const v1635 = stdlib.sub(v957, v957);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1684 = stdlib.sub(v957, v957);
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v865, v867, v871, v899, v900, v902, v903, v904, v909, v910, v946, v947, v948, v956, v1611, v1618, v1624, v1684],
      evt_cnt: 0,
      funcNum: 5,
      lct: v950,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./donate.rsh:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
        
        const {data: [], secs: v1688, time: v1687, didSend: v817, from: v1686 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./donate.rsh:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1690 = stdlib.addressEq(v871, v1686);
        stdlib.assert(v1690, {
          at: './donate.rsh:334:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1618) {
          const v1695 = stdlib.sub(v1684, v1684);
          sim_r.txns.push({
            amt: v1684,
            kind: 'from',
            to: v867,
            tok: v909
            });
          sim_r.txns.push({
            amt: v956,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1695,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1624,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v910
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v909
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v956,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1684,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1624,
            kind: 'from',
            to: v865,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v910
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v909
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc7, ctc1, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1688, time: v1687, didSend: v817, from: v1686 } = txn4;
    ;
    const v1690 = stdlib.addressEq(v871, v1686);
    stdlib.assert(v1690, {
      at: './donate.rsh:334:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1618) {
      const v1695 = stdlib.sub(v1684, v1684);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
const _ALGO = {
  appApproval: `#pragma version 5
txn RekeyTo
global ZeroAddress
==
assert
txn Lease
global ZeroAddress
==
assert
int 0
store 0
txn ApplicationID
bz alloc
byte base64()
app_global_get
dup
int 0
extract_uint64
store 1
int 8
extract_uint64
store 2
txn NumAppArgs
int 3
==
assert
txna ApplicationArgs 0
btoi
preamble:
// Handler 0
dup
int 0
==
bz l0_afterHandler0
pop
// check step
int 0
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
byte base64()
pop
txna ApplicationArgs 2
dup
len
int 128
==
assert
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
pop
// "CheckPay"
// "./util.rsh:47:6:dot"
// "[]"
int 100000
dup
bz l1_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l1_checkTxnK:
pop
// "CheckPay"
// "./util.rsh:47:6:dot"
// "[at ./donate.rsh:77:50:application call to \"construct\" (defined at: ./util.rsh:36:47:function exp)]"
load 252
store 251
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 33
app_global_put
pop
int 1
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l0_afterHandler0:
// Handler 1
dup
int 1
==
bz l2_afterHandler1
pop
// check step
int 1
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
extract 128 32
store 251
pop
txna ApplicationArgs 2
dup
len
int 160
==
assert
dup
extract 0 32
store 250
dup
extract 32 32
store 249
dup
int 64
extract_uint64
store 248
dup
int 72
extract_uint64
store 247
dup
int 80
extract_uint64
store 246
dup
int 88
extract_uint64
store 245
dup
int 96
extract_uint64
store 244
dup
int 104
extract_uint64
store 243
dup
int 112
extract_uint64
store 242
dup
int 120
extract_uint64
store 241
dup
int 128
extract_uint64
store 240
dup
int 136
extract_uint64
store 239
dup
int 144
extract_uint64
store 238
dup
int 152
extract_uint64
store 237
pop
load 241
load 240
==
!
store 236
// Nothing
// "./donate.rsh:106:6:dot"
// "[]"
load 236
assert
// Initializing token
int 100000
dup
bz l3_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l3_checkTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CurrentApplicationAddress
itxn_field AssetReceiver
load 241
itxn_field XferAsset
itxn_submit
int 0
l4_makeTxnK:
pop
// Initializing token
int 100000
dup
bz l5_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l5_checkTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CurrentApplicationAddress
itxn_field AssetReceiver
load 240
itxn_field XferAsset
itxn_submit
int 0
l6_makeTxnK:
pop
// "CheckPay"
// "./donate.rsh:106:6:dot"
// "[]"
int 100000
dup
bz l7_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l7_checkTxnK:
pop
// Nothing
// "./donate.rsh:124:10:application"
// "[]"
load 236
assert
// Nothing
// "./donate.rsh:125:10:application"
// "[]"
load 248
int 0
>=
load 248
int 99
<=
&&
assert
// Nothing
// "./donate.rsh:126:10:application"
// "[]"
load 246
int 0
>=
assert
// Nothing
// "./donate.rsh:127:10:application"
// "[]"
load 246
load 247
<
assert
int 20000
dup
bz l8_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l8_makeTxnK:
pop
int 100000
int 20000
-
int 80000
-
store 235
int 80000
dup
bz l9_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 253
itxn_field Receiver
itxn_submit
int 0
l9_makeTxnK:
pop
txn Sender
store 234
load 254
load 252
concat
load 251
concat
txn Sender
concat
load 250
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
load 241
itob
concat
load 240
itob
concat
load 237
itob
concat
load 235
itob
concat
load 234
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 10
app_global_put
pop
int 2
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l2_afterHandler1:
// Handler 2
dup
int 2
==
bz l10_afterHandler2
pop
// check step
int 2
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
extract 128 32
store 251
dup
int 160
extract_uint64
store 250
dup
int 168
extract_uint64
store 249
dup
int 176
extract_uint64
store 248
dup
int 184
extract_uint64
store 247
dup
int 192
extract_uint64
store 246
dup
int 200
extract_uint64
store 245
dup
int 208
extract_uint64
store 244
dup
int 216
extract_uint64
store 243
dup
int 224
extract_uint64
store 242
dup
extract 232 32
store 241
pop
txna ApplicationArgs 2
dup
len
int 0
==
assert
pop
// "CheckPay"
// "./donate.rsh:137:6:dot"
// "[]"
// "CheckPay"
// "./donate.rsh:137:6:dot"
// "[]"
int 1
dup
bz l11_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns AssetAmount
==
assert
load 245
dig 1
gtxns XferAsset
==
assert
int axfer
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns AssetReceiver
==
assert
l11_checkTxnK:
pop
// Just "sender correct"
// "./donate.rsh:137:6:dot"
// "[]"
load 241
txn Sender
==
assert
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
int 8
bzero
load 243
itob
concat
load 252
concat
int 1
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 242
itob
concat
byte base64(AAAAAAAAAAE=)
concat
int 8
bzero
concat
b loopBody3
l10_afterHandler2:
l12_afterHandler3:
// Handler 4
dup
int 4
==
bz l13_afterHandler4
pop
// check step
int 4
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
extract 128 32
store 251
dup
int 160
extract_uint64
store 250
dup
int 168
extract_uint64
store 249
dup
int 176
extract_uint64
store 248
dup
int 184
extract_uint64
store 247
dup
int 192
extract_uint64
store 246
dup
int 200
extract_uint64
store 245
dup
int 208
extract_uint64
store 244
dup
extract 216 32
store 243
dup
int 248
extract_uint64
store 242
dup
int 256
int 8
extract3
btoi
store 241
dup
int 264
int 8
extract3
btoi
store 240
dup
int 272
int 1
extract3
btoi
store 239
dup
int 273
int 8
extract3
btoi
store 238
pop
txna ApplicationArgs 2
dup
len
int 0
==
assert
pop
// "CheckPay"
// "./donate.rsh:334:7:dot"
// "[]"
// Just "sender correct"
// "./donate.rsh:334:7:dot"
// "[]"
load 253
txn Sender
==
assert
load 239
bz l14_ifF
load 241
dup
bz l15_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 254
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l15_makeTxnK:
pop
load 242
dup
bz l16_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l16_makeTxnK:
pop
load 241
dup
-
dup
bz l17_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l17_makeTxnK:
pop
load 238
dup
bz l18_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l18_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 246
itxn_field XferAsset
itxn_submit
int 0
l19_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l20_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l21_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l14_ifF:
load 242
dup
bz l22_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l22_makeTxnK:
pop
load 241
dup
bz l23_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l23_makeTxnK:
pop
load 238
dup
bz l24_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l24_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 246
itxn_field XferAsset
itxn_submit
int 0
l25_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l26_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l27_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l13_afterHandler4:
// Handler 5
dup
int 5
==
bz l28_afterHandler5
pop
// check step
int 7
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
extract 128 32
store 251
dup
int 160
extract_uint64
store 250
dup
int 168
extract_uint64
store 249
dup
int 176
extract_uint64
store 248
dup
int 184
extract_uint64
store 247
dup
int 192
extract_uint64
store 246
dup
int 200
extract_uint64
store 245
dup
int 208
extract_uint64
store 244
dup
extract 216 32
store 243
dup
int 248
extract_uint64
store 242
dup
int 256
int 8
extract3
btoi
store 241
dup
int 264
int 1
extract3
btoi
store 240
dup
int 265
int 8
extract3
btoi
store 239
dup
int 273
int 8
extract3
btoi
store 238
pop
txna ApplicationArgs 2
dup
len
int 0
==
assert
pop
// "CheckPay"
// "./donate.rsh:334:7:dot"
// "[]"
// Just "sender correct"
// "./donate.rsh:334:7:dot"
// "[]"
load 253
txn Sender
==
assert
load 240
bz l29_ifF
load 238
dup
bz l30_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 254
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l30_makeTxnK:
pop
load 242
dup
bz l31_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l31_makeTxnK:
pop
load 238
dup
-
dup
bz l32_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l32_makeTxnK:
pop
load 239
dup
bz l33_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l33_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 246
itxn_field XferAsset
itxn_submit
int 0
l34_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l35_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l36_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l29_ifF:
load 242
dup
bz l37_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l37_makeTxnK:
pop
load 238
dup
bz l38_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l38_makeTxnK:
pop
load 239
dup
bz l39_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l39_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 246
itxn_field XferAsset
itxn_submit
int 0
l40_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l41_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l42_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l28_afterHandler5:
// Handler 6
dup
int 6
==
bz l43_afterHandler6
pop
// check step
int 10
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
extract 128 32
store 251
dup
int 160
extract_uint64
store 250
dup
int 168
extract_uint64
store 249
dup
int 176
extract_uint64
store 248
dup
int 184
extract_uint64
store 247
dup
int 192
extract_uint64
store 246
dup
int 200
extract_uint64
store 245
dup
int 208
extract_uint64
store 244
dup
int 216
extract_uint64
store 243
dup
int 224
extract_uint64
store 242
dup
extract 232 32
store 241
dup
int 264
int 8
extract3
btoi
store 240
dup
int 272
int 8
extract3
btoi
store 239
dup
int 280
int 8
extract3
btoi
store 238
dup
int 288
int 8
extract3
btoi
store 237
dup
int 296
int 8
extract3
btoi
store 236
pop
txna ApplicationArgs 2
dup
len
int 9
==
assert
dup
store 235
pop
load 235
int 0
getbyte
int 0
==
bz l45_switchAfterBid_claim0
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
// Nothing
// "./donate.rsh:262:18:application"
// "[at ./donate.rsh:261:9:application call to [unknown function] (defined at: ./donate.rsh:261:9:function exp)]"
txn Sender
load 251
==
load 243
load 249
>=
&&
assert
load 238
dup
bz l46_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 251
itxn_field AssetReceiver
load 245
itxn_field XferAsset
itxn_submit
int 0
l46_makeTxnK:
pop
byte base64(AAAAAAAABGY=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
load 243
itob
load 242
itob
concat
load 241
concat
int 0
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 239
itob
concat
load 238
dup
-
itob
concat
load 237
itob
concat
b loopBody3
l45_switchAfterBid_claim0:
load 235
int 0
getbyte
int 1
==
bz l47_switchAfterBid_close0
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
byte base64(AAAAAAAABNU=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
load 243
itob
load 242
itob
concat
load 241
concat
load 240
load 242
<
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 239
itob
concat
load 238
itob
concat
load 237
itob
concat
b loopBody3
l47_switchAfterBid_close0:
load 235
int 0
getbyte
int 2
==
bz l48_switchAfterBid_getBid0
load 235
extract 1 8
dup
store 234
btoi
store 233
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
load 233
dup
bz l49_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns AssetAmount
==
assert
load 244
dig 1
gtxns XferAsset
==
assert
int axfer
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns AssetReceiver
==
assert
l49_checkTxnK:
pop
// Nothing
// "./donate.rsh:212:18:application"
// "[at ./donate.rsh:211:9:application call to [unknown function] (defined at: ./donate.rsh:211:9:function exp)]"
load 240
load 242
<
load 233
load 236
>=
&&
load 233
load 248
>=
&&
assert
load 243
dup
bz l50_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 241
itxn_field AssetReceiver
load 244
itxn_field XferAsset
itxn_submit
int 0
l50_makeTxnK:
pop
byte base64(AAAAAAAABVY=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
load 233
itob
load 242
int 60
+
itob
concat
txn Sender
concat
int 1
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 239
itob
concat
load 238
itob
concat
load 237
load 233
+
load 243
-
itob
concat
b loopBody3
l48_switchAfterBid_getBid0:
load 235
int 0
getbyte
int 3
==
bz l51_switchAfterBid_getPurchase0
load 235
extract 1 8
dup
store 234
btoi
store 233
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
load 233
dup
bz l52_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns AssetAmount
==
assert
load 244
dig 1
gtxns XferAsset
==
assert
int axfer
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns AssetReceiver
==
assert
l52_checkTxnK:
pop
// Nothing
// "./donate.rsh:238:18:application"
// "[at ./donate.rsh:237:9:application call to [unknown function] (defined at: ./donate.rsh:237:9:function exp)]"
load 240
load 242
>=
load 243
load 249
<
&&
load 233
load 249
>=
&&
assert
load 243
dup
bz l53_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 241
itxn_field AssetReceiver
load 244
itxn_field XferAsset
itxn_submit
int 0
l53_makeTxnK:
pop
byte base64(AAAAAAAABdA=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
load 233
itob
load 242
itob
concat
txn Sender
concat
int 0
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 239
itob
concat
load 238
itob
concat
load 237
load 233
+
load 243
-
itob
concat
b loopBody3
l51_switchAfterBid_getPurchase0:
load 235
int 0
getbyte
int 4
==
bz l54_switchAfterBid_touch0
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
// "CheckPay"
// "./donate.rsh:170:19:dot"
// "[]"
byte base64(AAAAAAAABj8=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
concat
load 243
itob
load 242
itob
concat
load 241
concat
int 1
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 239
itob
concat
load 238
itob
concat
load 237
itob
concat
b loopBody3
l54_switchAfterBid_touch0:
l44_switchK:
l43_afterHandler6:
int 0
assert
loopBody3:
dup
int 0
extract_uint64
store 255
dup
int 8
extract_uint64
store 254
dup
extract 16 32
store 253
dup
extract 48 1
btoi
store 252
dup
int 49
extract_uint64
store 251
dup
int 57
extract_uint64
store 250
dup
int 65
extract_uint64
store 249
dup
int 73
extract_uint64
store 248
dup
int 81
extract_uint64
store 247
pop
dup
extract 0 32
store 246
dup
extract 32 32
store 245
dup
extract 64 32
store 244
dup
extract 96 32
store 243
dup
extract 128 32
store 242
dup
int 160
extract_uint64
store 241
dup
int 168
extract_uint64
store 240
dup
int 176
extract_uint64
store 239
dup
int 184
extract_uint64
store 238
dup
int 192
extract_uint64
store 237
dup
int 200
extract_uint64
store 236
dup
int 208
extract_uint64
store 235
pop
load 252
bz l55_ifF
load 255
load 238
+
store 234
load 255
dup
int 100
/
load 237
*
+
dup
store 233
load 234
dup
load 233
>
select
store 232
load 246
load 245
concat
load 244
concat
load 243
concat
load 242
concat
load 241
itob
concat
load 240
itob
concat
load 239
itob
concat
load 238
itob
concat
load 237
itob
concat
load 236
itob
concat
load 235
itob
concat
load 255
itob
concat
load 254
itob
concat
load 253
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 232
itob
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 50
app_global_put
pop
int 10
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l55_ifF:
load 255
load 238
+
store 234
load 255
dup
int 100
/
load 237
*
+
dup
store 233
load 234
dup
load 233
>
select
store 232
load 247
int 100
/
store 231
load 241
load 231
*
store 230
load 255
load 240
>=
store 229
load 247
load 230
load 231
+
-
load 230
+
load 231
+
store 228
load 247
load 228
-
store 227
load 228
dup
bz l56_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 253
itxn_field AssetReceiver
load 235
itxn_field XferAsset
itxn_submit
int 0
l56_makeTxnK:
pop
load 229
bz l57_ifF
load 246
load 245
concat
load 244
concat
load 243
concat
load 242
concat
load 241
itob
concat
load 240
itob
concat
load 239
itob
concat
load 236
itob
concat
load 235
itob
concat
load 255
itob
concat
load 254
itob
concat
load 253
concat
load 249
itob
concat
load 248
itob
concat
load 232
itob
concat
load 229
itob // bool
substring 7 8
concat
load 227
itob
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 27
app_global_put
pop
int 4
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l57_ifF:
load 248
dup
-
store 226
load 248
dup
bz l58_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 243
itxn_field AssetReceiver
load 236
itxn_field XferAsset
itxn_submit
int 0
l58_makeTxnK:
pop
load 246
load 245
concat
load 244
concat
load 243
concat
load 242
concat
load 241
itob
concat
load 240
itob
concat
load 239
itob
concat
load 236
itob
concat
load 235
itob
concat
load 255
itob
concat
load 254
itob
concat
load 253
concat
load 249
itob
concat
load 232
itob
concat
load 229
itob // bool
substring 7 8
concat
load 227
itob
concat
load 226
itob
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 27
app_global_put
pop
int 7
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
updateState:
byte base64()
load 1
itob
load 2
itob
concat
app_global_put
checkSize:
load 0
dup
dup
int 1
+
global GroupSize
==
assert
txn GroupIndex
==
assert
int 1000
*
txn Fee
<=
assert
done:
int 1
return
alloc:
txn OnCompletion
int NoOp
==
assert
int 0
store 1
int 0
store 2
b updateState
`,
  appClear: `#pragma version 5
int 0
`,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 3,
  stateSize: 304,
  unsupported: [],
  version: 6
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v864",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v865",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v866",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v867",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v864",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v865",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v866",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v867",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v900",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v901",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v902",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v903",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v904",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v905",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v906",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v907",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v908",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v909",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v910",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v911",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v912",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v913",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e2",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e5",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_claim0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v1093",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e6",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1126",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1126",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1237",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1237",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1366",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1366",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1488",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1488",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1599",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1599",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_bids",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endSecs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_highestBidder",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_lastCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_minBid",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_recvAddr",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_reservePrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_royalties",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_startPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_tokenP",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_claim",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_close",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getBid",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getPurchase",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_touch",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v900",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v901",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v902",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v903",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v904",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v905",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v906",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v907",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v908",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v909",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v910",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v911",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v912",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v913",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m5",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_claim0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v1093",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m6",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 31080,
  Which: `oD`,
  version: 5,
  views: {
    Auction: {
      bids: `Auction_bids`,
      closed: `Auction_closed`,
      closes: `Auction_closes`,
      currentPrice: `Auction_currentPrice`,
      endCTime: `Auction_endCTime`,
      endSecs: `Auction_endSecs`,
      highestBidder: `Auction_highestBidder`,
      lastCTime: `Auction_lastCTime`,
      minBid: `Auction_minBid`,
      owner: `Auction_owner`,
      recvAddr: `Auction_recvAddr`,
      reservePrice: `Auction_reservePrice`,
      royalties: `Auction_royalties`,
      startPrice: `Auction_startPrice`,
      token: `Auction_token`,
      tokenP: `Auction_tokenP`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_claim": Bid_claim,
  "Bid_close": Bid_close,
  "Bid_getBid": Bid_getBid,
  "Bid_getPurchase": Bid_getPurchase,
  "Bid_touch": Bid_touch,
  "Constructor": Constructor,
  "Depositer": Depositer,
  "Relay": Relay
  };
export const _APIs = {
  Bid: {
    claim: Bid_claim,
    close: Bid_close,
    getBid: Bid_getBid,
    getPurchase: Bid_getPurchase,
    touch: Bid_touch
    }
  };
